import request from '@/utils/request'
import { getShopId } from '@/api/shop/shopApi'

// 获取员工列表
export function getStaffList(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/query.staff.infos',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 修改员工信息
export function modifyStaff(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/user.staff.modify',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 重置员工密码
export function resetStaffPassword(data) {
  data.shopId = getShopId()
  return new Promise((resolve, reject) => {
    request({
      url: '/user.resetStaffPwd',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

export function addStaff(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/user.staff.add',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 删除员工
export function deleteStaff(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/user.staff.delete',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 上传文件
export function uploadFile(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/upload/uploadFile',
      method: 'post',
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 根据组织级别获取组织
export function getOrgsByLevel(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/org.listOrgs',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// ===========================================================================
// REQ20260908：员工/配送员新体系（与骑手端员工管理同服务码、同表 s_store_staff）
// 旧 query.staff.infos 体系不含配送员审核状态与 roleType，以下能力为 PC 补齐部分：
// ===========================================================================

/**
 * 获取当前商户 storeId（s_store_staff.store_id 口径，10 开头）
 * 来源：登录后 initData 落盘的 hc_currentShopInfo（shop.listMyEnteredShops 返回的商铺对象携带 storeId）
 * @returns {String} 商户 storeId，未获取到时返回空串
 */
export function getStoreId() {
  try {
    const _shop = JSON.parse(window.localStorage.getItem('hc_currentShopInfo') || '{}')
    return _shop.storeId || ''
  } catch (e) {
    return ''
  }
}

/**
 * 员工列表（新体系，含配送员审核状态/角色）
 * storeStaff.listStoreStaff validate 仅 page/row；查询条件 BeanConvert 全字段匹配，必须带 storeId 过滤
 * @param {Object} params {storeId, page, row}
 */
export function listStoreStaff(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/storeStaff.listStoreStaff',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 编辑员工（新体系；角色 roleType=OWNER 店长/STAFF 店员 等动态字段更新）
 * UpdateStoreStaffCmd validate：storeStaffId/storeId 必填；仅非空字段更新，staffId 不可改
 * @param {Object} data {storeStaffId, storeId, roleType, ...}
 */
export function updateStoreStaff(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/storeStaff.updateStoreStaff',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 删除员工（新体系 s_store_staff 软删 status_cd=1；REQ20260909006）
 * storeStaff.deleteStoreStaff validate：storeStaffId/storeId 必填；
 * 操作人身份后端取请求头 user-id（登录上下文），须本店 OWNER，禁删店长/自己
 * @param {Object} data {storeStaffId, storeId}
 */
export function deleteStoreStaffApply(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/storeStaff.deleteStoreStaff',
      method: 'post',
      headers: {
        'user-id': window.localStorage.getItem('userId') || '-1'
      },
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}
